
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"8.5","cy":"8.092","r":"8","fill":"#F0F0EB"}}),_c('path',{attrs:{"d":"M11.822 2.63H5.144v10.92h6.68v-3.483H7.675V8.753h2.691V7.424h-2.69V6.111h4.146V2.63z","fill":"#008009"}})])
          )
        }
      }
    